<div class="events-table-scroll">
  <table
    mat-table
    multiTemplateDataRows
    matSort
    class="events-table mat-elevation-z1"
    [dataSource]="dataSource()"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="payee_case_reference_id">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "EVENTS.HEADERS.CASE_ID" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <div
          class="case-id-box"
          (click)="copyCaseIdToClipboard(element.payee_case_reference_id, $event)"
        >
          <span class="case-id-text">
            {{ element.payee_case_reference_id }}
          </span>
          <payee-icon
            name="copy-blue"
            width="14px"
            height="14px"
            class="case-id-icon"
          ></payee-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="debtor_name">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "EVENTS.HEADERS.DEBTOR" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @if (element.debtor_name) {
          <span>{{ element.debtor_name }}</span>
        } @else {
          <span class="empty-value">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "EVENTS.HEADERS.CLIENT" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          type="button"
          class="client-name-filter"
          (click)="filterByClient(element, $event)"
        >
          {{ element.client_name }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="happened_at">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ "EVENTS.HEADERS.HAPPENED_AT" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.happened_at | date: "yyyy.MM.dd. HH:mm" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="label">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "EVENTS.HEADERS.LABEL" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @let notificationRoutesTooltip = getEventLabelNotificationRoutesTooltip(element);
        @if (shouldLinkEventLabel(element) && getEventLabelMediaUuid(element); as mediaUuid) {
          <a
            class="event-label-text event-label-link"
            target="_blank"
            rel="noopener noreferrer"
            matTooltipPosition="above"
            matTooltipShowDelay="200"
            matTooltipClass="event-label-notification-tooltip"
            [href]="downloadUrlOfMediaUuid(mediaUuid)"
            [matTooltip]="notificationRoutesTooltip ?? ''"
            [matTooltipDisabled]="!notificationRoutesTooltip"
            (click)="$event.stopPropagation()"
          >
            {{ element.label }}
          </a>
        } @else {
          <span class="event-label-text">{{ element.label }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="to_state">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "EVENTS.HEADERS.NEW_STATUS" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @if (element.to_state; as toState) {
          <span
            class="state-box"
            [style.color]="toState.text_color"
            [style.background-color]="toState.background_color"
          >
            <span
              class="state-marker"
              [style.background-color]="toState.text_color"
            ></span>
            <span class="state">{{ toState.label }}</span>
          </span>
        } @else {
          <span class="empty-value">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-icon-button
          type="button"
          color="white"
          [matTooltip]="'EVENTS.GO_TO_CASE' | translate"
          [attr.aria-label]="'EVENTS.GO_TO_CASE' | translate"
          (click)="goToCase(element, $event)"
        >
          <payee-icon
            name="arrow-right-grey"
            width="16px"
            height="16px"
          ></payee-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        *matCellDef="let element"
        mat-cell
        class="expanded-detail-cell"
        [attr.colspan]="displayedColumns().length"
      >
        <div class="expanded-detail-inner">
          @if (element === expandedElement) {
            <div
              class="expanded-detail-content"
              animate.enter="expand-enter"
              animate.leave="expand-leave"
            >
              <div class="expanded-detail-content-inner">
                <div class="expanded-content-container">
                  <div class="section-container">
                    <h3 class="section-title">
                      {{ "EVENTS.DETAILS.NOTIFICATIONS" | translate }}
                    </h3>
                    @if (element.notifications?.length) {
                      <ul class="detail-file-list">
                        @for (notification of element.notifications; track notification.subject + (notification.media_uuid ?? "")) {
                          <li class="detail-notification-row">
                            <span class="detail-item">
                              @if (notification.media_uuid; as mediaUuid) {
                                <a
                                  class="detail-file detail-notification-link"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="200"
                                  matTooltipClass="event-label-notification-tooltip"
                                  [href]="downloadUrlOfMediaUuid(mediaUuid)"
                                  [matTooltip]="getRoutesTooltip(notification.routes) ?? ''"
                                  [matTooltipDisabled]="!getRoutesTooltip(notification.routes)"
                                  (click)="$event.stopPropagation()"
                                >
                                  <span>{{ notification.subject }}</span>
                                </a>
                              } @else {
                                <span>{{ notification.subject }}</span>
                              }
                            </span>
                          </li>
                        }
                      </ul>
                    } @else {
                      <div class="empty-detail">{{ "EVENTS.DETAILS.EMPTY" | translate }}</div>
                    }
                  </div>
                  <div class="section-container">
                    <h3 class="section-title">
                      {{ "EVENTS.DETAILS.FILES" | translate }}
                    </h3>
                    @if (element.files.length) {
                      <ul class="detail-file-list">
                        @for (file of element.files; track file.id) {
                          <li>
                            <a
                              class="detail-file"
                              target="_blank"
                              rel="noopener noreferrer"
                              [href]="downloadUrlOfFile(file)"
                            >
                              <span>{{ file.file_name }}</span>
                              <payee-icon
                                name="external-link-blue"
                                height="15px"
                              ></payee-icon>
                            </a>
                          </li>
                        }
                      </ul>
                    } @else {
                      <div class="empty-detail">{{ "EVENTS.DETAILS.EMPTY" | translate }}</div>
                    }
                  </div>
                  <div class="section-container">
                    <h3 class="section-title">
                      {{ "EVENTS.DETAILS.PAYMENTS" | translate }}
                    </h3>
                    @if (element.payments.length) {
                      @for (payment of element.payments; track payment.label + payment.currency_iso + payment.amount) {
                        <div class="detail-item">
                          <span>{{ payment.label }}:&nbsp;{{ payment.amount | number: "1.0" : "hu" }}&nbsp;{{ payment.currency_iso }}</span>
                          @if (payment.original_amount) {
                            <span class="detail-secondary">
                              &nbsp;/&nbsp;{{ payment.original_amount | number: "1.0" : "hu" }}&nbsp;{{ payment.currency_iso }}
                            </span>
                          }
                        </div>
                      }
                    } @else {
                      <div class="empty-detail">{{ "EVENTS.DETAILS.EMPTY" | translate }}</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns()"
      mat-header-row
      class="main-header events-table-header"
    ></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns()"
      mat-row
      class="element-row events-table-row"
      [class.expanded-row]="expandedElement === element"
      (click)="updateExpandedElement(element)"
    ></tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']"
      mat-row
      class="detail-row"
    ></tr>
  </table>
</div>

<mat-paginator
  class="mat-elevation-z1"
  showFirstLastButtons
  [length]="pagination()?.total ?? 0"
  [pageIndex]="(pagination()?.currentPage ?? 1) - 1"
  [pageSize]="pagination()?.perPage ?? 10"
  [pageSizeOptions]="[5, 10, 25]"
  (page)="page.emit($event)"
></mat-paginator>
